import { useEffect, useState } from "react";

let current = null;
export const setCurrentBook = (b) => { current = b; window.dispatchEvent(new Event("current-book")); };
export const useCurrentBook = () => {
  const [b, setB] = useState(current);
  useEffect(() => { const f = () => setB(current); window.addEventListener("current-book", f); return () => window.removeEventListener("current-book", f); }, []);
  return b;
};
